module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Branch Ledger List")]), _vm._v(" "), _c('span', {
    staticClass: "float-right"
  }, [(_vm.canAccess('branch-ledger-create')) ? _c('button', {
    staticClass: "btn btn-xs btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.newModal
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]) : _vm._e()]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.userType === 'admin') ? _c('div', {
    staticClass: "form-group col-sm-3"
  }, [_vm._m(1), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_id),
      expression: "form.branch_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_id'),
    },
    attrs: {
      "name": "branch_id",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.loadData]
    }
  }, [(!_vm.form.branch_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\r\n                    Select Company Branch\r\n                ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.branches), function(branch) {
    return _c('option', {
      key: branch.id,
      domProps: {
        "value": branch.id
      }
    }, [_vm._v("\r\n                    " + _vm._s(branch.name) + "\r\n                ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1) : _vm._e(), _c('br'), _c('br'), _vm._v(" "), _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "styleClass": "vgt-table condensed",
      "pagination-options": {
        enabled: true,
        perPage: 10,
        perPageDropdown: [10, 20, 30],
      },
      "line-numbers": true,
      "search-options": {
        enabled: true,
        trigger: 'enter',
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'BalanceAmt') ? _c('span', [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (props.row.balanceAmt > 0),
            expression: "props.row.balanceAmt > 0"
          }]
        }, [_vm._v(_vm._s(props.row.balanceAmt))])]) : _vm._e(), _vm._v(" "), (props.column.field == 'Status') ? _c('span', [(props.row.status == 'active') ? _c('span', {
          staticClass: "label label-success"
        }, [_vm._v("Active")]) : _c('span', {
          staticClass: "label label-danger"
        }, [_vm._v("InActive")])]) : _vm._e(), _vm._v(" "), (props.column.field == 'id') ? _c('span', [(_vm.canAccess('branch-ledger-update')) ? _c('button', {
          staticClass: "btn btn-success btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.editModal(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })]) : _vm._e()]) : _c('span', [_vm._v("\r\n                    " + _vm._s(props.formattedRow[props.column.field]) + "\r\n                  ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_vm._v("\r\n          List of all Group\r\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "newModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-md"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(2), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editMode),
      expression: "!editMode"
    }],
    staticClass: "modal-title"
  }, [_vm._v("Add New")]), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode),
      expression: "editMode"
    }],
    staticClass: "modal-title"
  }, [_vm._v("Update")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.editMode ? _vm.updateGroup() : _vm.createBranchLedger()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.userType === 'admin') ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_id),
      expression: "form.branch_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_id'),
    },
    attrs: {
      "name": "branch_id",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.loadData]
    }
  }, [(!_vm.form.branch_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\r\n                                Select Company Branch\r\n                            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.branches), function(branch) {
    return _c('option', {
      key: branch.id,
      domProps: {
        "value": branch.id
      }
    }, [_vm._v("\r\n                                " + _vm._s(branch.name) + "\r\n                            ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.editMode === false) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ledger),
      expression: "ledger"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('ledger_id'),
    },
    attrs: {
      "name": "ledger_id",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ledger = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.getAccount()
      }]
    }
  }, [(!_vm.ledger) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\r\n                                Select Ledger\r\n                            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.ledgers), function(ledger) {
    return _c('option', {
      key: ledger.id,
      domProps: {
        "value": ledger
      }
    }, [_vm._v("\r\n                                " + _vm._s(ledger.name) + "\r\n                            ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "ledger_id"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.editMode === false) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.remark),
      expression: "form.remark"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('remark')
    },
    attrs: {
      "name": "remark"
    },
    domProps: {
      "value": (_vm.form.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "remark", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "remark"
    }
  })], 1) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editMode),
      expression: "!editMode"
    }],
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" CREATE ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode),
      expression: "editMode"
    }],
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" UPDATE ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(" CANCEL")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "",
      "data-original-title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove",
      "data-toggle": "tooltip",
      "title": "",
      "data-original-title": "Remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Branch Name "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Branch Name "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Ledger Name "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Description "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7605b7ca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/accounting/BranchLedger.vue
// module id = 872
// module chunks = 0